import type { Config } from './types';

export const config: Config = {
  env: 'master',
  variant: {
    tvOSBundleId: 'com.creativelabs.fit52.master.2',
    androidPackageName: {
      default: 'com.creativelabs.fit52tv.master',
      play: 'com.creativelabs.fit52.master',
    },
    name: 'HiNote Life TV Master',
  },
  api: { baseURL: 'https://master.fit52life.com/api' },
  pairingLink: { baseURL: 'https://go-master.hinote.com' },
  downloadLink: { baseURL: 'https://go-master.hinote.com' },
  unlockCode: 'fittv',
  shouldInitializeSentry: true,
  enableLogsStreamByDefault: true,
  sentry: {
    dsn: 'https://77fd48771d379ee263eb6b350028631e@o249262.ingest.us.sentry.io/4511021405306880',
    project: 'fit52-tv-web-master',
  },
};
